export enum TutorStatus {
  Active = 'ACTIVE',
  Onboarding = 'ONBOARDING',
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
}
